import { GetRefundListRequest } from "../domains/use-case.domain";

export const getUserConfigurationKey = () => ["getUserConfiguration"];
export const getServiceConfigurationKey = () => ["getServiceConfiguration"];
export const getRefundListKey = ({
  PageNumber,
  PageSize,
  States,
  CreationDateFrom,
  CreationDateTo,
  PaymentCodes,
  MaxAmount,
  MinAmount,
  Pan,
}: GetRefundListRequest) => [
  "getRefundList",
  PageNumber,
  PageSize,
  States,
  CreationDateFrom,
  CreationDateTo,
  PaymentCodes,
  MaxAmount,
  MinAmount,
  Pan,
];
export const getRefundInfoKey = (code: string) => ["getRefundInfo", code];
export const getWalletBalanceKey = () => ["getWalletBalance"];
export const getLatestRefundInfoByPaymentCodeKey = (code: string) => ["getLatestRefundInfoByPaymentCode", code];
